import { normalize, schema } from "normalizr";
import type { IMedia } from "../../../model/unityObject";
import type { Content } from "./dataTypes/Content";
import type { ValidContentTypeObject } from "./dataTypes/ContentType";

export const contentEntity = new schema.Entity<Content>("contents");

export const mediaEntity = new schema.Entity<IMedia>("medias");

export const contentTypeObjectEntity = new schema.Entity<ValidContentTypeObject>(
  "contentTypeObjects",
  {
    content: contentEntity,
    source_media: mediaEntity,
    source_image_2d: mediaEntity,
    source_image: mediaEntity,
    source_audio: mediaEntity,
    answer_1_image: mediaEntity,
    answer_2_image: mediaEntity,
    answer_3_image: mediaEntity,
    source_pdf: mediaEntity,
  },
);

type NormalizedContentTypeObjectEntities = {
  contents: { [id: number]: Content };
  contentTypeObjects: { [id: number]: ValidContentTypeObject };
  medias?: { [id: number]: IMedia };
};
export const normalizeContentTypeObject = (data: unknown) => {
  return normalize<ValidContentTypeObject, NormalizedContentTypeObjectEntities, number>(
    data,
    contentTypeObjectEntity,
  );
};
